const styles = theme => ({
  topBar: {
    padding: '0px 0px 16px 0px',
    // borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    gap: '8px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 0 8px 0',
    },
  },
  totalResults: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '21px',
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    marginRight: '8px',
    // padding: '8px',
  },

  iconClickableBtn: {
    background: `${theme.palette.primary.grey} !important`,
    padding: '3px',
    minWidth: 'auto',
    minHeight: 'auto',
    marginLeft: '8px',
  },

  iconClickable: {
    width: '13px',
    height: '13px',
    cursor: 'pointer',
  },

  removeFilterContainer: {
    background: theme.palette.primary.grey,
    padding: '8px 12px',
    borderRadius: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '35px',
  },

  MultiFilterContainer: {
    background: theme.palette.primary.white,
    padding: '12px',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    position: 'absolute',
    top: '40px',
    left: '0',
    boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.1)',
    minWidth: '240px',
    maxHeight: '300px',
    overflowY: 'auto',
    zIndex: '100',

    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0px 0px 20px #ededed',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      '-webkit-box-shadow': 'inset 0px 0px 20px #484456',
      borderRadius: '20px',
    },
  },

  removeFilterDropDownItem: {
    display: 'flex',
    borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
    padding: '14px 0',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  MultipleParent: {
    position: 'relative',
  },
  multiContainerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
    paddingBottom: '12px',
  },

  removeFilterLabel: {
    minWidth: 'auto',
    color: theme.palette.primary.adgmBlack,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '18px',
    whiteSpace: 'nowrap',
  },
  removeFilterDropDownLabel: {
    color: theme.palette.secondary.dim,
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '21px',
    textTransform: 'capitalize',
  },
  clearAllBtn: {
    color: theme.palette.secondary.dim,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '18px',
    textAlign: 'end',
    cursor: 'pointer',
  },
  removeFilterBtn: {
    background: 'transparent !important',
    minWidth: 'auto',
    padding: '0',
    marginLeft: '16px',
    borderRadius: '50%',

    '& img': {
      width: '18px',
      height: '18px',
    },
  },
});

export default styles;
